module.exports = __webpack_public_path__ + "static/media/24.fc0bcb92.mp3";